import Heading from '../../../reuseableComponents/Heading'
function AboutText() {
  return (
    <div className="my-auto text-start">
      <Heading heading="About" alignment="text-start mb-4" />
      <p className="text-sm lg:text-base">
        A Software developer Proficient in ReactJs, Next.js and React Native. It was all
        started from my college days when I bought my first laptop and entered
        in the world of software-development. Usually, I spend 7 to 9 hours a day
        with my laptop as I am coding, building beautiful web-applications that
        are live on internet and continously improving my chops by learning new
        skills day by day.
      </p>
    </div>
  )
}

export default AboutText
